(() => {
  const initializeAjour = (scope = document) => {
    const roots = [];

    if (scope instanceof Element && scope.matches('[data-ajour-lp]')) {
      roots.push(scope);
    }

    scope.querySelectorAll?.('[data-ajour-lp]').forEach((root) => roots.push(root));

    roots.forEach((root) => {
      if (root.dataset.ajourInitialized === 'true') return;

      root.dataset.ajourInitialized = 'true';
      const targets = Array.from(root.querySelectorAll('[data-ajour-reveal]'));

      if (!targets.length) return;

      root.classList.add('is-reveal-ready');

      if (
        !('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        targets.forEach((target) => target.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        {
          rootMargin: '0px 0px -10% 0px',
          threshold: 0.08,
        }
      );

      targets.forEach((target) => observer.observe(target));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAjour(), { once: true });
  } else {
    initializeAjour();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAjour(event.target);
  });
})();
